import Meta from '@/components/common/Meta'

import AffordableSelfStorageServicesPage from '@/v2/components/pages/landing-pages/affordable-self-storage-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/affordable-self-storage-services-page'

interface AffordableSelfStorageServicesPageProps {}

const Page: React.FC<AffordableSelfStorageServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.affordable_self_storage_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.affordable_self_storage_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.affordable_self_storage_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <AffordableSelfStorageServicesPage />
    </>
  )
}

export default Page
